<template>
  <CModal
      :title="title"
      :color="color"
      :size="size"
      :show.sync="modal"
    >
        <span v-html="text"></span>
      <!-- Are you sure you want to delete <b>{{userToDelete.name}}</b>. -->
        <div slot="footer">
          <CButton
          class="mr-2"
          color="secondary"
          square
          size="sm"
          @click="onCancel()"
        > Cancel </CButton>
          <CButton
            :color="color"
            square
            size="sm"
            @click="onOkay()"
          > OK </CButton>
      </div>
    </CModal>
</template>

<script>
export default {
    name: 'TheModal',
    computed: {
        modal: {
            get() {
                return this.showModal
            },
            set(newValue){
                return newValue
            }
        }
    },
    props: {
        color: {
            type: String
        },
        size: {
            type: String
        },
        showModal: {
            type: Boolean
        },
        text:{ 
            type: String
        },
        title: {
            type: String
        }
    },
    methods: {
        onCancel () {
            this.$emit('cancel')
        },
        onOkay () {
            this.$emit('okay')
        }
    }
}
</script>

<style>

</style>